<template>
  <div
    class="saving-wrap new-line-recharge"
    :class="{ 'has-commission': hasCommission }"
    v-loading.fullscreen.lock="payLoading"
    element-loading-text="订单支付中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <!-- <img class="header-img" src="./images/line-recharge.png" /> -->
    <div class="saving-content" v-loading="loading">
      <p>儲值帳號ID</p>
      <div class="save-uuid">
        <div class="uuid-input" @click="checkLogin()">
          <input
            v-model="rechargeUuid"
            maxlength="7"
            placeholder="請輸入您的nicee帳戶ID"
            :readonly="!allowChangeUuid"
            @input="inputUuid"
          />
        </div>
        <div v-if="rechargeUserInfo" class="user-nickname">
          暱稱：{{ rechargeUserInfo.nickname }}
        </div>
        <div class="get-uuid" v-else>在nicee APP「個人中心」頭像下方獲取ID</div>
      </div>
      <p>選擇金額</p>
      <!-- <p class="tip-info" v-if="activitySwitch">
        活動期間每個優惠儲值金額僅限享受一次滿贈優惠
      </p> -->
      <div class="saving-number">
        <div
          class="number-item"
          :class="{
            checked: item.iapItemId === checkedId
          }"
          @click="changeNumber(item)"
          v-for="(item, index) in numberArr"
          :key="index"
        >
          <div class="price-box">
            <img class="gold-img" src="~@/assets/image/icons/gold-icon.png" />
            <span class="get-gold">{{ item.receivedAmount }}</span>
          </div>

          <div class="user-amount">NT${{ item.paymentAmount }}</div>
          <span
            v-if="activitySwitch ? item.rechargeAward : item.residentAward"
            class="send-gold"
            >送{{
              activitySwitch ? item.rechargeAward : item.residentAward
            }}鑽</span
          >
          <!-- <span class="send-gold">送{{ 13 }}</span> -->
        </div>
      </div>

      <p class="pay-type">選擇付費方式</p>
      <template v-if="cardList && cardList.length">
        <div v-for="(item, index) of cardList.slice(0, 2)" :key="index">
          <div class="pay-type-list" @click="selectTappayCard(item.id)">
            <div>
              <img
                class="pay-type-image"
                src="./images/visa.png"
                alt=""
                v-if="item.type === 1"
              />
              <img
                class="pay-type-image"
                src="./images/mastercard.png"
                alt=""
                v-else-if="item.type === 2"
              />
              <img
                class="pay-type-image"
                src="./images/jcb.png"
                alt=""
                v-else-if="item.type === 3"
              />
              <img
                class="pay-type-image"
                src="./images/Amex.png"
                alt=""
                v-else-if="item.type === 5"
              />
              <span> ************{{ item.lastCode }} </span>
            </div>
            <div
              class="checkbox"
              :class="{
                'is-check':
                  checkCardId == item.id &&
                  checkPayType === payTypeEnum.TAPPAYCARD
              }"
            >
              <i
                class="el-icon-check"
                v-show="checkPayType === payTypeEnum.TAPPAYCARD"
              ></i>
            </div>
          </div>
        </div>
      </template>

      <div class="pay-type-list" @click="selectPayType(payTypeEnum.CREDIT)">
        <div class="activity-switch-box">
          <img class="pay-type-image" src="./images/CREDIT.png" />
          <div>
            <div>
              {{
                payShopEnum.CREDIT === 'stripe' ? '信用卡(1:1限免)' : '信用卡'
              }}
              <br />
              <span class="credit-type">(Visa/MasterCard/銀聯/AmEx)</span>
            </div>
            <!-- <div class="activity-info">限時鑽石贈送</div> -->
          </div>
        </div>
        <div
          class="checkbox"
          :class="{
            'is-check': checkPayType === payTypeEnum.CREDIT && !isUseJCBcredit
          }"
        >
          <i
            class="el-icon-check"
            v-show="checkPayType === payTypeEnum.CREDIT && !isUseJCBcredit"
          ></i>
        </div>
      </div>
      <Tappay
        ref="tappay"
        :rechargeUuid="rechargeUuid"
        :visible="
          paymentType === paymentTypeConfig.tapPay &&
            checkPayType === payTypeEnum.CREDIT
        "
        @submit="tappayRecharge"
        v-if="!isUseJCBcredit"
      ></Tappay>
      <div
        class="pay-type-list"
        @click="selectPayType(payTypeEnum.CREDIT, { isJBC: true })"
      >
        <div>
          <img class="pay-type-image" src="./images/CREDIT.png" />
          <span>
            信用卡 <br />
            <span class="credit-type">(Visa/MasterCard/JCB)</span>
          </span>
        </div>
        <div class="checkbox" :class="{ 'is-check': isUseJCBcredit }">
          <i class="el-icon-check" v-show="isUseJCBcredit"></i>
        </div>
      </div>
      <Tappay
        ref="tappay"
        :rechargeUuid="rechargeUuid"
        :visible="
          paymentType === paymentTypeConfig.tapPay &&
            checkPayType === payTypeEnum.CREDIT
        "
        @submit="tappayRecharge"
        v-if="isUseJCBcredit"
      ></Tappay>
      <div class="pay-type-list" @click="selectPayType(payTypeEnum.ATM)">
        <div>
          <img class="pay-type-image" src="./images/ATM.png" />
          <span> ATM轉賬 </span>
        </div>
        <div
          class="checkbox"
          :class="{ 'is-check': checkPayType === payTypeEnum.ATM }"
        >
          <i
            class="el-icon-check"
            v-show="checkPayType === payTypeEnum.ATM"
          ></i>
        </div>
      </div>
      <div class="pay-type-list" @click="selectPayType(payTypeEnum.CVS)">
        <div>
          <img class="pay-type-image" src="./images/CVS.png" />
          <span> 商超代碼 </span>
        </div>
        <div
          class="checkbox"
          :class="{ 'is-check': checkPayType === payTypeEnum.CVS }"
        >
          <i
            class="el-icon-check"
            v-show="checkPayType === payTypeEnum.CVS"
          ></i>
        </div>
      </div>
      <div class="pay-type-list" @click="selectPayType(payTypeEnum.PAYPAL)">
        <div>
          <img class="pay-type-image paypal" src="./images/paypal.png" />
        </div>
        <div
          class="checkbox"
          :class="{ 'is-check': checkPayType === payTypeEnum.PAYPAL }"
        >
          <i
            class="el-icon-check"
            v-show="checkPayType === payTypeEnum.PAYPAL"
          ></i>
        </div>
      </div>
      <!-- <div class="pay-type-list" @click="selectPayType(payTypeEnum.WECHAT)">
        <div>
          <img class="pay-type-image wechat" src="./images/weChatPay.png" />
        </div>
        <div
          class="checkbox"
          :class="{ 'is-check': checkPayType === payTypeEnum.WECHAT }"
        >
          <i
            class="el-icon-check"
            v-show="checkPayType === payTypeEnum.WECHAT"
          ></i>
        </div>
      </div> -->

      <div
        class="more"
        v-show="!showMore && moreCardList && moreCardList.length"
        @click="showMore = !showMore"
      >
        <img class="icon-more" src="./images/icon_down.png" alt="" />
        <span>更多</span>
      </div>
      <template v-if="moreCardList && moreCardList.length && showMore">
        <div
          class="pay-type-list"
          v-for="item of moreCardList"
          :key="item.id"
          @click="selectTappayCard(item.id)"
        >
          <div>
            <img
              class="pay-type-image"
              src="./images/visa.png"
              alt=""
              v-if="item.type === 1"
            />
            <img
              class="pay-type-image"
              src="./images/mastercard.png"
              alt=""
              v-else-if="item.type === 2"
            />
            <img
              class="pay-type-image"
              src="./images/jcb.png"
              alt=""
              v-else-if="item.type === 3"
            />
            <img
              class="pay-type-image"
              src="./images/Amex.png"
              alt=""
              v-else-if="item.type === 5"
            />
            <span> ************{{ item.lastCode }} </span>
          </div>
          <div
            class="checkbox"
            :class="{
              'is-check':
                checkCardId == item.id && checkPayType == payTypeEnum.TAPPAYCARD
            }"
          >
            <i
              class="el-icon-check"
              v-show="checkPayType === payTypeEnum.TAPPAYCARD"
            ></i>
          </div>
        </div>
      </template>

      <template v-if="showEmail">
        <p class="email-title">電子信箱</p>
        <div class="tip-wrap">
          填寫電子信箱用以收取支付通知信與電子發票。
        </div>
        <input
          v-model="email"
          class="email-input"
          placeholder="請填寫付款人電子郵箱"
        />
      </template>
    </div>
    <div class="confrim-save-box" v-if="hasCommission">
      <div class="paypal-box" v-show="paymentType === paymentTypeConfig.payPal">
        <div :id="submitId"></div>
      </div>

      <Submit
        :paymentAmount="checkedNumber"
        :iapLoading="iapLoading"
        :taxation="iapItemSelected.taxAmount"
        :commission="iapItemSelected.chargesAmount"
        :giftAmmount="
          activitySwitch
            ? iapItemSelected.rechargeAward
            : iapItemSelected.residentAward
        "
        :isPaypal="paymentType === paymentTypeConfig.payPal"
        :isLimitedExemption="isLimitedExemption"
        @submit="handleRecharge"
      ></Submit>
    </div>
    <div class="confrim-save-btn-m" :class="{ addBorder: scrolling }" v-else>
      <div
        class="paypal-btn-box"
        :id="submitId"
        v-show="paymentType === paymentTypeConfig.payPal"
      ></div>
      <button
        class="c-button"
        :disabled="disableBtn"
        v-show="paymentType != paymentTypeConfig.payPal"
        @click="handleRecharge"
      >
        去儲值
        <i class="el-icon-loading" v-if="iapLoading"></i>
      </button>
    </div>
    <form :action="paymentObj.payUrl" method="post" id="payment-form">
      <input type="hidden" name="MerchantID" :value="paymentObj.storeId" />
      <input type="hidden" name="RespondType" value="JSON" />
      <input type="hidden" name="CheckValue" :value="rechargeInfo.nonce" />
      <input
        type="hidden"
        name="TimeStamp"
        :value="Math.floor(rechargeInfo.createTime / 1000)"
      />
      <input type="hidden" name="Version" value="1.2" />
      <input
        type="hidden"
        name="MerchantOrderNo"
        :value="rechargeInfo.orderNo"
      />
      <input type="hidden" name="Amt" :value="checkedNumber" />
      <input type="hidden" name="LoginType" value="0" />
      <input type="hidden" name="BrowserProcess" value="1" />
      <input type="hidden" name="Email" :value="email" />
      <input type="hidden" name="ItemDesc" value="儲值" />
      <input type="hidden" name="ReturnURL" :value="paymentObj.hostUrl" />
      <!-- 蓝新支付的后台回调通知地址(不知道为什么测试环境，直接商店配置不生效，所以在前端配置)   -->
      <input
        type="hidden"
        name="NotifyURL"
        :value="notifyURL"
        v-if="notifyURL"
      />
      <!-- <input type="hidden" name="CREDIT" value="1" >
      <input type="hidden" name="CVS" value="1" > -->
      <input type="hidden" :name="checkSavingMethod.code" value="1" />
      <input
        type="hidden"
        :name="checkSavingMethod.validity"
        :value="checkSavingMethod.time"
      />
    </form>
    <form :action="funPointPaymentObj.payUrl" method="post" id="funpoint-form">
      <input
        type="hidden"
        name="MerchantID"
        :value="funpointResult.MerchantID"
      />
      <input
        type="hidden"
        name="MerchantTradeNo"
        :value="funpointResult.MerchantTradeNo"
      />
      <input
        type="hidden"
        name="MerchantTradeDate"
        :value="funpointResult.MerchantTradeDate"
      />
      <input
        type="hidden"
        name="PaymentType"
        :value="funpointResult.PaymentType"
      />
      <input
        type="hidden"
        name="TotalAmount"
        :value="funpointResult.TotalAmount"
      />
      <input type="hidden" name="TradeDesc" :value="funpointResult.TradeDesc" />
      <input type="hidden" name="ItemName" :value="funpointResult.ItemName" />
      <input type="hidden" name="ReturnURL" :value="funpointResult.ReturnURL" />
      <input
        type="hidden"
        name="ChoosePayment"
        :value="funpointResult.ChoosePayment"
      />
      <input
        type="hidden"
        name="CheckMacValue"
        :value="funpointRechargeInfo.nonce"
      />
      <input
        type="hidden"
        name="EncryptType"
        :value="funpointResult.EncryptType"
      />
      <input
        type="hidden"
        name="ClientBackURL"
        :value="funpointResult.ClientBackURL"
      />
    </form>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';
import { bindOrder } from '@/api/order';
import Tappay from './tappay-page.vue';
import Submit from './submit.vue';
import inobounce from 'inobounce';
import { mapGetters } from 'vuex';

export default {
  components: {
    Tappay,
    Submit
  },
  data() {
    const localPaytype = localStorage.getItem('LAST_PAYTYPE');
    return {
      rechargeUserInfo: null,
      // rechargeUuid: '',
      scrolling: false,
      rechargeInfo: {},
      paymentObj: {
        payUrl: '',
        storeId: '',
        nonce: '',
        hostUrl: ''
      },
      funpointResult: {
        EncryptType: 1,
        ItemName: '心約餘額',
        PaymentType: 'aio',
        MerchantTradeDate: '',
        ReturnURL: '',
        MerchantID: '1000031',
        TotalAmount: 12,
        MerchantTradeNo: 'PM1666335865091385',
        TradeDesc: '心約餘額',
        ChoosePayment: 'ALL',
        ClientBackURL: ''
      },
      //FunPoint支付
      funpointRechargeInfo: {},
      funPointPaymentObj: {
        payUrl: '', // FunPoint金流支付url
        hostUrl: '' // 付款完成通知回傳網址
      },
      checkSavingMethod: {},
      checkedNumber: null,
      checkedId: null,
      numberArr: [],
      activitySwitch: false,
      deadLineTime: 0,
      paypalButton: '', // paypal按钮,
      paypalId: '', //paypal訂單id
      payLoading: false,
      // 金流支付方式
      paymentTypeConfig: {
        lanXin: 'lanXin',
        funPoint: 'funPoint',
        fomoPay: 'fomoPay',
        payPal: 'payPal',
        tapPay: 'tapPay',
        stripe: 'stripe'
      },
      showMore: false, // 是否顯示更多支付方式
      email: localStorage.getItem('LAST_EMAIL') || '',
      // 当前已选的支付方式
      checkPayType:
        localPaytype && localPaytype != 'PAYPAL' ? localPaytype : 'CREDIT',
      // 支付类型
      payTypeEnum: {
        CREDIT: 'CREDIT',
        CVS: 'CVS',
        ATM: 'ATM',
        WECHAT: 'WECHAT',
        TAPPAYCARD: 'TAPPAYCARD',
        PAYPAL: 'PAYPAL'
      },
      // 每种支付方式所選用的金流支付商
      payShopEnum: {
        CVS: 'lanXin', //lanXin funPoint
        CREDIT: 'stripe', //lanXin payPal tapPay funPoint stripe
        ATM: 'lanXin', //lanXin funPoint
        WECHAT: 'fomoPay', // fomoPay
        // CARD: 'TAPPAYCARD'
        PAYPAL: 'payPal' // payPal
      },
      cardList: [], //银行卡列表
      checkCardId: localStorage.getItem('LAST_CARDID'),
      checkTappayCardInfo: null, // 選擇支付的卡號信息
      htmlOriginalFontSize: null, // html原始字体大小
      isJCBCREDIT: false, // 是否是jcb信用卡
      loading: false,
      iapLoading: false,
      controller: new AbortController(),
      iapItemSelected: {}
    };
  },
  watch: {
    rechargeUuid: {
      handler: function(uuid) {
        if (uuid.length >= 6) {
          this.clearTimer();
          this.searchUuidTimer = setTimeout(() => {
            this.getUserInfo(uuid).then(result => {
              if (result) {
                if (this.rechargeUserInfo && this.rechargeUserInfo.uuid) {
                  this.loading = true;
                  this.$http
                    .get('/payment/rechargeIsHold', { userUuid: uuid })
                    .then(({ data }) => {
                      if (data) {
                        this.$confirm({
                          message:
                            '您當前賬號的信用異常，暫停下單/儲值功能。如有疑問，請搜索添加"nicee小管家"咨詢',
                          title: '提示',
                          showCancelButton: false,
                          showConfirmButton: false,
                          showClose: false,
                          // confirmButtonText: '確定',
                          closeOnClickModal: false,
                          customClass: 'line-recharge-dialog-center'
                        }).then(() => {
                          // this.$router.push({ path: '/home' });
                        });
                      } else {
                        Promise.all([
                          this.getCardList(),
                          this.getPayShopConfig()
                        ]).finally(() => {
                          if (
                            this.checkPayType == this.payTypeEnum.TAPPAYCARD &&
                            this.checkCardId
                          ) {
                            this.checkPayType = 'CREDIT';
                            this.selectTappayCard(this.checkCardId);
                          } else {
                            if (
                              this.checkPayType == this.payTypeEnum.TAPPAYCARD
                            ) {
                              this.checkPayType = 'CREDIT';
                            }
                            this.selectPayType(this.checkPayType);
                          }
                          this.getIapList();
                          this.loading = false;
                        });
                      }

                      this.searchUuidTimer = null;
                    })
                    .catch(() => {});
                }
              }
            });
          }, 500);
        }
        if (this.rechargeUserInfo) {
          if (this.rechargeUserInfo.uuid !== uuid) this.rechargeUserInfo = null;
        }
      },
      immediate: true
    },
    paymentMethod: {
      handler: function(nVal, oVal) {
        if (nVal != oVal) {
          this.getIapList();
        } else {
          if (!(this.numberArr && this.numberArr.length)) {
            this.getIapList();
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.checkLogin();
    this.initHtmlFontSize();
    this.funPointPaymentObj.payUrl = process.env.VUE_APP_FUNPOINT;
    this.funPointPaymentObj.hostUrl = this.getHostUrl();
    document.title = 'nicee陪玩-越儲值越動心';
    this.paymentObj.payUrl = process.env.VUE_APP_PAY_URL;
    this.paymentObj.storeId = process.env.VUE_APP_MERCHANTID;
    this.paymentObj.hostUrl = this.getHostUrl();
    if (this.$route.query.redirect) {
      this.paymentObj.hostUrl = decodeURIComponent(this.$route.query.redirect);
    }
    // this.getRechargeUuid();
  },
  mounted() {
    document.title = 'nicee陪玩-越儲值越動心';
    this.isSuccess();
    this.renderButton();
    if (this.isIOS) {
      inobounce.enable();
    }
  },

  beforeDestroy() {
    this.resetHtmlFontSize();
    document.title = 'nicee陪玩-台灣最大遊戲陪玩平台-正妹陪玩在線搶單';
    this.clearTimer();
    inobounce.disable();
  },
  computed: {
    ...mapGetters(['userInfo']),
    rechargeUuid() {
      return this.isAppRecharge
        ? this.$route.query.uuid
        : this.userInfo
        ? this.userInfo.uuid
        : '';
    },
    moreCardList() {
      return this.cardList.slice(2) || [];
    },
    deadLineDate() {
      let date = new Date(this.deadLineTime);
      return date.getMonth() + 1 + '月' + date.getDate() + '日';
    },
    hasGift() {
      return this.numberArr.some(item => {
        return item.rechargeAwardSwitch;
      });
    },
    disableBtn() {
      return !(
        this.rechargeUserInfo &&
        this.rechargeUserInfo.uuid &&
        this.checkSavingMethod &&
        this.checkedNumber &&
        this.iapLoading === false
      );
    },

    // paypal提交按鈕的id
    submitId() {
      return 'submit' + ((Math.random() * 1000) | 0);
    },
    // 蓝新支付后台通知回调地址
    notifyURL() {
      return process.env.VUE_APP_LANXIN_NOTIFYURL;
    },
    // 是否是line储值通道
    isLine() {
      return this.$route.query && this.$route.query.openExternalBrowser == 1;
    },
    // 从内购储值跳转过来
    isAppRecharge() {
      return this.source === 'app-recharge';
    },
    // 從什麼渠道過來
    source() {
      return this.$route.query ? this.$route.query.from : '';
    },
    // 支付方式
    payOptions() {
      return {
        // 信用卡
        CREDIT: {
          lanXin: {
            value: 'LineLanXinCreditCard',
            payMethodInfo: {
              code: 'CREDIT',
              validity: 'TradeLimit',
              time: 900
            }
          },
          payPal: {
            value: 'PayPal_CheckOut'
          },
          tapPay: {
            value: 'LINE_TAB_PAY_CARD'
          },
          funPoint: {
            value: 'LINE_FUN_POINT'
          },
          stripe: {
            value: 'LINE_StripeCheckOut'
          }
        },
        // 超商代碼繳費
        CVS: {
          lanXin: {
            value: 'LineLanXinSupermarket',
            payMethodInfo: {
              code: 'CVS',
              validity: 'ExpireDate',
              time: this.validTime
            }
          },
          funPoint: {
            value: 'LINE_FUN_POINT'
          }
        },
        // ATM转账
        ATM: {
          lanXin: {
            value: 'LineLanXinATM',
            payMethodInfo: {
              code: 'VACC',
              validity: 'ExpireDate',
              time: this.validTime
            }
          },
          funPoint: {
            value: 'LINE_FUN_POINT'
          }
        },
        // WECHAT
        WECHAT: {
          fomoPay: {
            value: 'LINE_FOMO_WX_WEB'
          }
        },
        PAYPAL: {
          payPal: {
            value: 'LINE_PayPal_CheckOut'
          }
        }
        // 直接使用信用卡号
        // CARD: {
        //   tappay: {
        //     value: 'LINE_TAB_PAY_CARD'
        //   }
        // }
      };
    },
    // 支付方式
    paymentMethod() {
      // jcb信用卡使用funpoint支付
      if (this.isUseJCBcredit) {
        return this.payOptions.CREDIT.tapPay.value;
      }
      if (this.checkPayType === this.payTypeEnum.TAPPAYCARD) {
        return this.payOptions.CREDIT.tapPay.value;
      } else {
        return this.payOptions[this.checkPayType][
          this.payShopEnum[this.checkPayType]
        ]['value'];
      }
    },
    // 支付金流
    paymentType() {
      // jcb信用卡使用funpoint支付
      if (this.isUseJCBcredit) {
        return this.paymentTypeConfig.tapPay;
      }
      if (this.checkPayType === this.payTypeEnum.TAPPAYCARD) {
        return this.paymentTypeConfig.tapPay;
      } else {
        return this.payShopEnum[this.checkPayType];
      }
    },
    showEmail() {
      const list = [
        this.paymentTypeConfig.payPal,
        this.paymentTypeConfig.fomoPay,
        this.paymentTypeConfig.stripe
      ];
      return !list.includes(this.paymentType);
    },
    //是否使用jcb信用卡支付
    isUseJCBcredit() {
      return this.checkPayType === this.payTypeEnum.CREDIT && this.isJCBCREDIT;
    },
    //对应金流的档位
    niceeItemType() {
      if (this.hasCommission) {
        // nicee储值挡位
        const niceeItemConfig = {
          // tapPay: 'LINE_TAB_PAY_CARD',
          // funPoint: 'LINE_FUN_POINT',
          payPal: 'PayPal_CheckOut',
          tapPay: 'LINE_TAB_PAY_CARD',
          funPoint: 'LinePay',
          // payPal: 'LinePay',
          fomoPay: 'LinePay',
          // spgateway: 'LineLanXinATM',
          // lanXin: 'LinePay', // 臨時設置保持和原來一樣
          stripe: 'LINE_StripeCheckOut',
          default: 'LinePay'
        };

        if (this.paymentType == this.paymentTypeConfig.lanXin) {
          return this.checkPayType == this.payTypeEnum.CVS
            ? 'LineLanXinSupermarket'
            : 'LineLanXinATM';
        } else {
          return niceeItemConfig[this.paymentType];
        }
      } else {
        return 'LinePay';
      }
    },
    // 白名单测试用户，可以使用最低档位10元进行测试，stripe和paypal为40元
    isWhiteTestList() {
      return (
        this.rechargeUserInfo &&
        this.rechargeUserInfo.uuid &&
        ['3698758', '250226', '4071691', '1054918'].includes(
          this.rechargeUserInfo.uuid
        )
      );
    },
    allowChangeUuid() {
      return false;
      // return this.$route.query.uuid ? false : true;
    },
    //是否有手续费
    hasCommission() {
      //正式环境无正式用途，只是方便测试用
      if (
        process.env.VUE_APP_ENV === 'test' ||
        process.env.VUE_APP_ENV === 'development'
      ) {
        return this.$route.query.noCommission === 'true' ? false : true;
      } else {
        return true;
      }
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    // 是否限免
    isLimitedExemption() {
      return this.paymentType === 'stripe';
    }
  },
  methods: {
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '3.2vw'; //设计稿宽375 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    },
    clearTimer() {
      if (!this.searchUuidTimer) return;
      clearTimeout(this.searchUuidTimer);
      this.searchUuidTimer = null;
    },
    inputUuid(e) {
      if (isNaN(e.data - 0)) {
        this.rechargeUuid = this.rechargeUuid.substring(
          0,
          this.rechargeUuid.length - 1
        );
      }
    },
    getUserInfo(uuid) {
      return this.$http
        .get('/user/nickname', {
          uuid
        })
        .then(({ data }) => {
          if (data.uuid === this.rechargeUuid) {
            this.rechargeUserInfo = data;
            return true;
          }
        })
        .catch(({ code }) => {
          switch (code) {
            case 430: {
              this.$message.error('該用戶不存在，請檢查ID是否正確');
              break;
            }
          }
          return false;
        });
    },
    getIapList() {
      if (this.iapLoading) {
        this.controller.abort();
        this.controller = new AbortController();
      }
      // let signal = ;
      this.iapLoading = true;

      this.$http
        .get(
          '/iap/item/list/recharge',
          {
            paymentMethod: this.niceeItemType
          },
          {
            signal: this.controller.signal
          }
        )
        .then(({ data }) => {
          if (data && Array.isArray(data.iapItemsVo)) {
            this.deadLineTime = data.datetime;
            this.numberArr = data.iapItemsVo;
            if (!this.isWhiteTestList) {
              this.numberArr = this.numberArr.filter(item => {
                if (
                  this.paymentType === this.paymentTypeConfig.payPal ||
                  this.paymentType === this.paymentTypeConfig.stripe
                ) {
                  return item.receivedAmount != 40;
                } else {
                  return item.receivedAmount != 10;
                }
              });
            }
            this.activitySwitch = data.activitySwitch;
            const iapItem = this.numberArr.find(item => {
              return (
                item.receivedAmount === this.iapItemSelected.receivedAmount
              );
            });
            if (iapItem) {
              this.changeNumber(iapItem);
            } else {
              this.changeNumber({ paymentAmount: null, checkedId: null });
            }
          }
        })
        .finally(() => {
          this.iapLoading = false;
        });
    },
    changeNumber(iapItem) {
      const { paymentAmount, iapItemId } = iapItem;
      this.checkedNumber = paymentAmount;
      this.checkedId = iapItemId;
      this.iapItemSelected = iapItem;
    },
    getHostUrl() {
      if (this.$route.query.redirect) {
        return decodeURIComponent(this.$route.query.redirect);
      }
      return location.origin + location.pathname + '?' + 'isSuccess=1';
    },
    recharge() {
      if (!this.validEmail()) {
        return;
      }
      this.payLoading = true;
      this.paymentObj.hostUrl =
        this.getHostUrl() +
        `&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&from=${this.source}`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          email: this.email
        })
        .then(async data => {
          this.rechargeInfo = data.data;
          this.rememberRechargeInfo();
          // this.paymentObj.nonce = data.nonce
          if (this.checkSavingMethod.code !== 'CREDIT') {
            let cur = new Date();
            let validDate = new Date(cur.getTime() + 48 * 60 * 60 * 1000);
            let monthper = validDate.getMonth() > 8 ? '' : '0';
            let month = validDate.getMonth() + 1;
            let monthString = monthper + month.toString();
            let datePer = validDate.getDate() > 9 ? '' : '0';
            let dateString = datePer + validDate.getDate().toString();
            let validTime =
              validDate.getFullYear().toString() + monthString + dateString;
            this.checkSavingMethod.time = validTime;
          }
          window.sessionStorage.setItem('LINE_RECHARGE', 1);
          await this.reportPayType(data.data.orderNo);
          this.$nextTick(() => {
            document.querySelector('#payment-form').submit();
          });
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // 验证邮箱必填
    validEmail() {
      if (!this.email) {
        this.$message.error('請輸入您的電子郵箱');
        return false;
      } else if (!/^(\w+\.)*\w+@\w+(.\w+)+$/.test(this.email)) {
        this.$message.error('電子郵箱格式不正確');
        return false;
      } else {
        return true;
      }
    },
    // 获取funpoint的收款方式
    getFunpointPayment() {
      if (this.checkPayType === 'CREDIT') {
        return 'Credit';
      }
      if (this.checkPayType === 'ATM') {
        return 'ATM';
      }
      if (this.checkPayType === 'CVS') {
        return 'CVS';
      }
      return 'ALL';
    },
    //FunPoint金流
    funPointRecharge() {
      if (!this.validEmail()) {
        return;
      }
      this.funPointPaymentObj.hostUrl =
        this.getHostUrl() +
        `&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&from=${this.source}`;
      const funpointChoosePayment = this.getFunpointPayment();
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: this.funPointPaymentObj.hostUrl,
          email: this.email,
          funpointChoosePayment
        })
        .then(async ({ data }) => {
          await this.reportPayType(data.orderNo);
          this.funpointRechargeInfo = data;
          this.funpointResult = data.result;
          this.rememberRechargeInfo();
          this.$nextTick(() => {
            document.querySelector('#funpoint-form').submit();
          });
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // tappay提交表單
    tappaySubmit() {
      if (!this.validEmail()) {
        return;
      }
      this.$refs.tappay.handleSubmit();
    },
    // tappay支付
    tappayRecharge(submitObj) {
      const { remember, prime, cardId } = submitObj;
      const isDevelopment = process.env.VUE_APP_ENV === 'development'; //是否是開發環境
      this.payLoading = true;
      const successUrl = `${
        isDevelopment ? 'https://test.nicee.tw' : location.origin
      }${location.pathname}?uuid=${this.rechargeUuid}&from=${
        this.source
      }&isSuccess=1&`;
      const params = {
        uuid: this.rechargeUuid,
        amount: this.checkedNumber,
        iapItemId: this.checkedId,
        paymentMethod: this.paymentMethod,
        tabPalPrime: prime,
        successUrl: successUrl,
        email: this.email
      };
      if (!cardId) {
        params['remember'] = remember;
      }
      this.$http
        .post('/payment/recharge', params)
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            this.rememberRechargeInfo();
            window.open(data.result.url, '_self');
            this.payLoading = false;
            if (cardId && this.checkPayType == this.payTypeEnum.TAPPAYCARD) {
              localStorage.setItem('LAST_CARDID', cardId || '');
            }
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },

    // 處理tappay支付狀態
    isTappaySuccess() {
      const { isTappay, status } = this.$route.query;
      if (isTappay === 'true' && status) {
        this.$router.go(-2);
      }
    },
    isSuccess() {
      const url = this.$route.query;
      if (url.isSuccess) {
        if (url.isSuccess == 1) {
          this.$message.success('儲值成功');
          if (this.isAppRecharge) {
            this.$router.go(-(window.history.length - 1));
            return;
          }
        } else {
          this.$message.error('儲值失敗');
        }
        const query = this.$route.query;
        const newQuery = {};

        Object.keys(query).forEach(key => {
          let filterKeys = ['uuid', 'from'];
          if (filterKeys.includes(key)) {
            newQuery[key] = query[key];
          }
        });
        this.$router.replace({
          name: 'LineRecharge',
          query: newQuery
        });
      }
    },
    //获取uuid
    // getRechargeUuid() {
    //   if (this.$route.query && this.$route.query.uuid) {
    //     this.rechargeUuid = this.$route.query.uuid;
    //   }
    //   else {
    //     this.rechargeUuid = localStorage.getItem('LAST_UUID') || '';
    //   }
    // },
    // 生成paypal支付按鈕
    renderButton() {
      const paypayScriptConfig = {
        'client-id': process.env.VUE_APP_CLIENT_ID,
        'disable-funding': 'credit,card',
        currency: 'TWD',
        intent: 'authorize'
      };
      // 按鈕相關設置
      const buttonConfig = {
        style: {
          height: 55
          // disableMaxWidth: true
        },
        // 創建paypal訂單
        createOrder: this.createPaypalOrder,
        // 支付成功
        onApprove: this.paypalPaySuccess,
        onError: err => {
          console.warn(err);
          this.$message({
            message: 'paypal支付失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onCancel: err => {
          console.warn(err);
          this.$message({
            message: '已取消paypal支付',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onClick: async (data, actions) => {
          if (!this.rechargeUuid) {
            this.$message.error('請輸入要儲值的帳號ID');
            return actions.reject();
          }
          if (!this.rechargeUserInfo) {
            this.$message.error('該用戶不存在，請檢查账号ID是否正確');
            return actions.reject();
          }
          if (!this.checkedNumber) {
            this.$message.error('請选择储值金额');
            return actions.reject();
          }
          try {
            this.payLoading = true;
            const result = await this.$http.post('/payment/recharge', {
              uuid: this.rechargeUuid,
              amount: this.checkedNumber,
              iapItemId: this.checkedId,
              paymentMethod: this.paymentMethod,
              payPalId: 'paypalId'
            });
            if (result && result.data) {
              await this.reportPayType(result.data.orderNo);
              this.rememberRechargeInfo();
              this.rechargeInfo = result.data;
              return actions.resolve();
            } else {
              throw new Error('创建订单失败');
            }
          } catch (err) {
            this.$message({
              message: '创建订单失败',
              type: 'error',
              customClass: 'paypal-status'
            });
            return actions.reject();
          }
        }
      };
      // 用來渲染按鈕的元素id
      const id = '#' + this.submitId;
      loadScript(paypayScriptConfig)
        .then(paypal => {
          this.paypalButton = paypal.Buttons(buttonConfig);
          this.paypalButton.render(id).catch(error => {
            console.error('failed to render the PayPal Buttons', error);
          });
        })
        .catch(error => {
          console.error('failed to load the PayPal JS SDK script', error);
        });
    },
    // 創建paypal訂單
    async createPaypalOrder(data, actions) {
      return actions.order
        .create({
          purchase_units: [
            {
              // 商品
              amount: {
                currency_code: 'TWD', //新台幣
                value: this.checkedNumber //金額
              },
              invoice_id: this.rechargeInfo.orderNo
            }
          ]
        })
        .then(async orderData => {
          return orderData;
        })
        .catch(() => {
          this.$message({
            message: 'paypal创建订单失败',
            type: 'error',
            customClass: 'paypal-status'
          });
        });
    },
    // 支付成功
    paypalPaySuccess(data, actions) {
      // Authorize the transaction
      actions.order
        .authorize()
        .then(authorization => {
          // Get the authorization id
          var authorizationID =
            authorization.purchase_units[0].payments.authorizations[0].id;
          this.payLoading = false;
          this.rememberRechargeInfo();
          this.$message({
            message: '支付成功',
            type: 'success',
            customClass: 'paypal-status'
          });
          // 充值nicee币
          bindOrder({
            orderId: data.orderID,
            authId: authorizationID,
            orderNo: this.rechargeInfo.orderNo
          });
        })
        .catch(() => {
          this.$message({
            message: 'paypal获取授权失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        });
    },
    // fomo支付
    fomopayRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?isSuccess=1&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&from=${this.source}&`;
      const cancelUrl = `${location.origin}${location.pathname}?iisSuccess=0&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&from=${this.source}&`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.paymentMethod,
          successUrl: successUrl,
          cancelUrl: cancelUrl
        })
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },
    // 处理支付
    handleRecharge() {
      if (!this.checkSavingMethod) {
        this.showMesssage('請選擇付費方式');
        return;
      }
      if (!this.checkedNumber) {
        this.showMesssage('請選擇金額');
        return;
      }
      if (this.iapLoading) {
        this.showMesssage('請選擇金額');
        return;
      }
      if (!(this.rechargeUserInfo && this.rechargeUserInfo.uuid)) {
        this.showMesssage('請輸入uuid');
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.lanXin) {
        this.recharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.funPoint) {
        this.funPointRecharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.tapPay) {
        if (this.checkPayType === this.payTypeEnum.TAPPAYCARD) {
          if (!this.validEmail()) {
            return;
          }
          this.tappayRecharge(this.checkTappayCardInfo);
        } else {
          this.tappaySubmit();
          return;
        }
      }
      if (this.paymentType === this.paymentTypeConfig.fomoPay) {
        this.fomopayRecharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.stripe) {
        this.stripeRecharge();
        return;
      }
    },
    showMesssage(message) {
      this.$confirm({
        message: message,
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickModal: true,
        customClass: 'line-recharge-message-box'
      });
    },
    //上报支付渠道
    async reportPayType(orderNo) {
      //deskType 1/新版收银台 2/旧版
      // type. 1/官网包 2/line 3/pcWEB页面
      try {
        return await this.$http.post('/payment/recharge/event/save', {
          deskType: 1,
          type: this.isLine ? 2 : 1,
          uuid: this.rechargeUuid,
          orderNo
        });
      } catch (error) {
        console.log(error);
        return;
      }
    },
    // stripe支付
    stripeRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?uuid=${this.rechargeUuid}&isSuccess=1&from=${this.source}&`;
      const cancelUrl = `${location.origin}${location.pathname}?uuid=${this.rechargeUuid}&isSuccess=0&from=${this.source}&`;

      const params = {
        uuid: this.rechargeUuid,
        amount: this.checkedNumber,
        iapItemId: this.checkedId,
        paymentMethod: this.paymentMethod,
        successUrl: successUrl,
        cancelUrl: cancelUrl,
        email: this.email
      };
      this.$http
        .post('/payment/recharge', params)
        .then(async ({ data }) => {
          if (data.nonce) {
            await this.reportPayType(data.orderNo);
            this.rememberRechargeInfo();
            window.open(data.nonce, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },
    // 選擇支付類型
    selectPayType(payType, otherConfig) {
      this.checkCardId = null;
      this.checkPayType = payType;
      if (otherConfig) {
        if (otherConfig.isJBC) {
          //是否使用jcb信用卡支付
          this.checkSavingMethod = this.payOptions.CREDIT.tapPay.value;
          this.isJCBCREDIT = true;
          return;
        }
      }
      this.isJCBCREDIT = false;
      this.checkSavingMethod =
        this.payOptions[payType][this.payShopEnum[payType]]['payMethodInfo'] ||
        {};
    },
    // 选择银行卡
    selectTappayCard(id) {
      this.checkPayType = this.payTypeEnum.TAPPAYCARD;
      this.checkCardId = id;
      this.checkTappayCardInfo = {
        cardId: id,
        prime: 'cardToken-' + id
      };
    },
    // 获取银行卡列表
    async getCardList() {
      try {
        const url = `/payment/tabPay/cardList?userUuid=${this.rechargeUserInfo.uuid}`;
        const { data } = await this.$http.get(url);
        this.cardList = data || [];
        return true;
      } catch (error) {
        return false;
      }
    },
    // 获取信用卡配置
    async getPayShopConfig() {
      try {
        const { data } = await this.$http.get('/payment/recharge/action', {
          userUuid: this.rechargeUuid
        });
        //       "data": {
        // 	"appleMethod": "",//apple方式 Apple
        // 	"atmMethod": "",//atm方式 LanXin FUN_POINT
        // 	"cardMethod": "",//信用卡方式  LanXin FUN_POINT TAB_PAY PayPal
        // 	"supermarketMethod": "",//商超代码方式 LanXin FUN_POINT
        // 	"wechatMethod": ""//wechat方式 FOMO
        // },
        // 每种金流的支付商
        // payShopEnum: {
        //   CVS: 'lanXin', //lanXin funPoint
        //   CREDIT: 'payPal', //lanXin payPal tapPay funPoint
        //   ATM: 'lanXin', //lanXin funPoint
        //   WECHAT: 'fomoPay', // fomoPay
        // },
        if (data) {
          switch (data.supermarketMethod) {
            case 'LanXin':
              this.payShopEnum.CVS = 'lanXin';
              break;
            case 'FUN_POINT':
              this.payShopEnum.CVS = 'funPoint';
              break;
            default:
              break;
          }
          switch (data.cardMethod) {
            case 'LanXin':
              this.payShopEnum.CREDIT = 'lanXin';
              break;
            case 'FUN_POINT':
              this.payShopEnum.CREDIT = 'funPoint';
              break;
            case 'TAB_PAY':
              this.payShopEnum.CREDIT = 'tapPay';
              break;
            case 'PayPal':
              this.payShopEnum.CREDIT = 'payPal';
              break;
            case 'Stripe':
              this.payShopEnum.CREDIT = 'stripe';
              break;
            default:
              break;
          }
          switch (data.atmMethod) {
            case 'LanXin':
              this.payShopEnum.ATM = 'lanXin';
              break;
            case 'FUN_POINT':
              this.payShopEnum.ATM = 'funPoint';
              break;
            default:
              break;
          }
          switch (data.wechatMethod) {
            case 'FOMO':
              this.payShopEnum.WECHAT = 'fomoPay';
              break;
            default:
              break;
          }
          this.email = this.allowChangeUuid ? '' : data.email ? data.email : '';
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    // 记住支付信息
    rememberRechargeInfo() {
      localStorage.setItem('LAST_UUID', this.rechargeUuid || '');
      localStorage.setItem('LAST_PAYTYPE', this.checkPayType || 'CREDIT');
    },
    checkLogin() {
      if (!this.rechargeUuid) {
        this.$util
          .Login({ phoneLoginDialog: true, inviterUuid: this.uuid })
          .then(async () => {
            await this.$store.dispatch('app/getUserAccount');
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@function changeRem($value) {
  @return $value / 12;
}
.new-line-recharge {
  padding-top: 40px;
  padding-top: calc(
    40px + constant(safe-area-inset-top)
  ); /* 兼容iOS 11.2及以下版本 */
  padding-top: calc(40px + env(safe-area-inset-top));
  * {
    box-sizing: border-box;
  }
  &.has-commission {
    display: flex;
    height: 100vh;
    overflow: hidden;
    flex-direction: column;
    padding-bottom: calc(
      30px + constant(safe-area-inset-bottom)
    ); /* 兼容iOS 11.2及以下版本 */
    padding-bottom: calc(
      30px + env(safe-area-inset-bottom)
    ); /* 兼容iOS 11.2+版本 */
    .saving-content {
      overflow: auto;
      flex: 1;
    }
    .confrim-save-btn-m {
      flex: none;
      height: changeRem(42rem);
    }
    .confrim-save-box {
      position: relative;
      .paypal-box {
        position: absolute;
        width: 14rem;
        height: 5.16667rem;
        // height: 3.5rem;
        right: 1.5rem;
        opacity: 0;
        z-index: 10;
        > div {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .header-img {
    width: 100%;
    display: block;
  }
  .saving-content {
    -webkit-overflow-scrolling: touch;
    padding: 0 1.5rem 1.5rem;
    p {
      font-weight: bold;
      font-size: 1.333rem;
      padding-bottom: 1rem;
    }
    .save-uuid {
      // border-bottom: 1px solid $color-split;
      // padding-bottom: 28px;
      // margin-bottom: 28px;
      margin-bottom: 3rem;
      .uuid-input input {
        padding: 1rem 1rem;
        width: 100%;
        background: #f9f9f9;
        border: 0.083rem solid rgba(232, 234, 238, 1);
        box-sizing: border-box;
        border-radius: 0.333rem;
        // font-weight: 500;
        font-size: 1.167rem;
        // line-height: 16px;
        color: rgba(34, 44, 67, 1);
        &::placeholder {
          color: $color-gray-3;
        }
        &:focus {
          background: #ffffff;
          box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        }
      }
      .user-nickname {
        font-size: 1rem;
        line-height: 1.417rem;
        margin-top: 0.333rem;
        color: rgb(254, 127, 56);
      }
      .get-uuid {
        font-size: 1rem;
        line-height: 1.417rem;
        color: $color-gray-3;
        margin-top: 0.333rem;
      }
    }
    .saving-number {
      display: flex;
      flex-wrap: wrap;
      margin-left: -0.75rem;
      margin-bottom: 2.4rem;
      .number-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex: none;
        width: 8.917rem;
        height: 4.75rem;
        border-radius: 0.333rem;
        border: 0.083rem solid rgba(140, 148, 170, 0.3);
        margin-left: 0.75rem;
        margin-bottom: 0.75rem;
        position: relative;
        .price-box {
          display: flex;
          align-items: center;
          padding-bottom: 0.542rem;
          color: rgba(34, 44, 67, 1);
          font-weight: bold;
          font-size: 1.167rem;
          .gold-img {
            width: 1.333rem;
            margin-right: 0.42rem;
          }
        }
        .user-amount {
          color: rgba(99, 109, 134, 1);
          font-size: 1rem;
        }
        &.checked {
          border-radius: 0.333rem;
          border: 0.083rem solid rgba(254, 127, 56, 1);
          box-sizing: border-box;
          background: rgba(254, 127, 56, 0.05);
        }
        .send-gold {
          position: absolute;
          font-size: 12px;
          padding: 0 8px;
          line-height: 18px;
          display: inline-block;
          color: #ffffff;
          border-radius: 10px;
          right: 0;
          top: 0;
          transform: translateY(-50%);
          background-color: #fc4688;
        }
      }
    }
    .pay-type-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 4rem;
      color: rgba(34, 44, 67, 1);
      font-size: 1.167rem;
      > div {
        &:first-child {
          display: flex;
          align-items: center;
        }
        &.activity-switch-box {
          display: flex;
          align-items: flex-start;
          .activity-info {
            font-size: 12px;
            padding: 0 8px;
            line-height: 20px;
            display: inline-block;
            color: #ffffff;
            border-radius: 10px;
            right: 0;
            top: 0;
            transform: translateY(-50%);
            background-color: #fc4688;
            margin-top: 14px;
          }
        }
      }

      .pay-type-image {
        width: 2.5rem;
        margin-right: 0.83rem;
        &.wechat {
          width: 10rem;
        }
        &.paypal {
          width: 6rem;
          max-height: 100%;
          margin-left: 0.4rem;
        }
      }
      .credit-type {
        color: #a1a1a1;
        font-size: 14px;
      }
      .checkbox {
        width: 1.833rem;
        height: 1.833rem;
        border-radius: 50%;
        border: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        justify-content: center;
        &.is-check {
          border: none;
          background: #fed838;
          font-size: 1.2rem;
          font-weight: bold;
          .el-icon-check {
            display: inline-block;
            margin-top: 1px;
            color: black;
          }
        }
      }
    }
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.98rem;
      .icon-more {
        width: 1.4rem;
        margin-right: 0.6rem;
      }
    }
    .email-title {
      margin-top: 1.8rem;
    }
    .tip-wrap {
      font-size: 1.2rem;
      line-height: 1.8rem;
      color: $color-gray-3;
      margin-bottom: 1.8rem;
    }
    .email-input {
      padding: 1rem 1rem;
      width: 100%;
      background: #f9f9f9;
      border: 0.083rem solid rgba(232, 234, 238, 1);
      box-sizing: border-box;
      border-radius: 0.333rem;
      // font-weight: 500;
      font-size: 1.167rem;
      // line-height: 16px;
      color: rgba(34, 44, 67, 1);
      &::placeholder {
        color: $color-gray-3;
      }
      &:focus {
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .confrim-save-btn-m {
    width: 100vw;
    height: 90px;
    position: fixed;
    background: #fff;
    bottom: 0;
    padding: 1.083rem;
    font-size: 1.333rem;
    z-index: 2;
    .c-button {
      display: block;
      width: 28.583rem;
      height: 4rem;
      border-radius: 0.167rem;
      background: rgba(8, 182, 58, 1);
      line-height: 4rem;
      font-weight: 500;
      background: #08b63a;
      color: #fff;
      text-align: center;
      cursor: pointer;
      &:disabled {
        background: #f1f4f6 !important;
        color: rgba(99, 103, 134, 0.3) !important;
      }
    }
    .deadline {
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.line-recharge-dialog-center,
.line-recharge-message-box {
  .el-message-box__header,
  .el-message-box__message,
  .el-message-box__title {
    text-align: center !important;
  }
}
@media screen and (max-width: 599px) {
  .line-recharge-dialog-center {
    &.fps-message-box {
      vertical-align: middle;
      max-width: 80%;
    }
    .el-message-box__btns {
      display: none;
    }
  }
  .line-recharge-message-box {
    &.fps-message-box {
      vertical-align: middle;
      max-width: 80%;
      .el-message-box__message p {
        text-align: center !important;
        font-size: 18px;
        padding: 30px 0;
      }
    }
  }
}
</style>
